import {
  SelectedFilters,
  useCampaignStore,
} from '@lidea/shared/data-access/core';
import { keepPreviousData, useQuery } from '@tanstack/react-query';
import { useMemo } from 'react';

import { plotKeys } from './../../keys/plot-keys';

interface UsePlotsProps {
  selectedFilters: SelectedFilters;
  page: number;
  sort?: string;
}
export function usePlots(props: UsePlotsProps) {
  const campaignId = useCampaignStore((s) => s.campaignId);
  const plots = useQuery({
    ...plotKeys.paginated({
      filters: props.selectedFilters,
      page: props.page,
      sort: props.sort,
      campaignId,
    }),
    enabled: !!campaignId,
    placeholderData: keepPreviousData,
  });

  const plotsAsOptions = useMemo(() => {
    if (!plots.data) {
      return [];
    }
    return plots.data.results.features.map((p) => ({
      value: p.id as number,
      label: p.properties.name,
    }));
  }, [plots.data]);

  return { ...plots, plotsAsOptions };
}

export default usePlots;
